import { useEffect } from 'react';

const JivoChat = () => {
    useEffect(() => {

        const jivoChatScript = document.createElement('script');
        jivoChatScript.src = 'https://code.jivosite.com/widget/pAu0aDYLtr';
        jivoChatScript.async = true;

        jivoChatScript.onload = () => {
            if (window.JivoChat) {
                console.log('JivoChat loaded successfully.');
            }
        };

        document.body.appendChild(jivoChatScript);

        return () => {
            document.body.removeChild(jivoChatScript);
        };
    }, []);

    return null;
};

export default JivoChat;
